


export default {
	dialogues : []
}



// WEBPACK FOOTER //
// ./src/app-store.js